var React = require('react');

function DropDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.16666 4.5L0.558223 0.749999L7.7751 0.75L4.16666 4.5Z","fill":"#747271"}));
}

DropDown.defaultProps = {"width":"20","height":"20","viewBox":"-2 0 12 6","fill":"none"};

module.exports = DropDown;

DropDown.default = DropDown;
